export const CLASS_COLOR_TAGS_DROPDOWN = 'color-tags-dropdown';
export const CLASS_COLOR_TAGS_PALETTE = 'card-details__color-tags-dropdown--palette';
export const MIN_WIDTH_FOR_3_COLUMNS = 680;
